import styled from "styled-components";

export const TooltipContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  .__react_component_tooltip.show {
    opacity: 1;
  }
`;
